import { Box, Grid, Paper, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAButton from "../config/components/BAButton";
import BAInput from "../config/components/BAInput";
import { useEffect, useState } from "react";
import BADatepicker from "../config/components/BADatepicker";
import BATextarea from "../config/components/BATextarea";
import DeleteIcon from "@mui/icons-material/Delete";
import { Get, Post } from "../config/apimethods/apimethods";
import { useNavigate, useParams } from "react-router-dom";
import BAShowError from "../config/components/BAShowerror";
import { detailsList } from "../config/enums";
import BAGrid from "../config/components/BAGrid";
import BAIconbutton from "../config/components/BAIconbutton";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import CheckIcon from '@mui/icons-material/Check';
import BAModal from "../config/components/BAModal";


export default function EstimateForm() {
    const [model, setModel] = useState({})
    const [message, setMessage] = useState()
    const [showMessage, setShowMessage] = useState(false)
    const [saveLoader, setSaveLoader] = useState(false)
    const [filterVal, setFilterVal] = useState()
    const [filterDetailList, setFilterDetailList] = useState([])
    const [selectedList, setSelectedList] = useState([]);
    const [groupNameList, setGroupNameList] = useState([]);
    const [groupName, setGroupName] = useState('')
    const [openOtherModal, setOpenOtherModal] = useState(false);
    const [otherModel, setOtherModel] = useState({});

    const params = useParams()

    let filterCat = (val) => {
        let arr = detailsList.filter(x => (x.name.toLowerCase()).includes(val.toLowerCase()))
        setFilterDetailList([...arr])
    }

    const activeGroupName = (i) => {
        console.log(i)
        groupNameList.forEach((x, ind) => {
            if (ind != i) {
                x.isActive = false
            } else {
                x.isActive = true
            }
        })
        setGroupNameList([...groupNameList])
    }

    const addGroupName = () => {
        let obj = {
            groupName: groupName,
            isActive: true
        }
        groupNameList.push(obj)
        activeGroupName(groupNameList.length - 1)
        setGroupNameList([...groupNameList])
        setGroupName('')
    }

    const fillModel = (key, val) => {
        model[key] = val
        setModel({ ...model })
    }
    let addInRecept = (e) => {
        let activeGroup = groupNameList && groupNameList.length > 0 ? groupNameList.find(x => x.isActive) : null
        setSelectedList([...selectedList, { ...e, groupName: activeGroup ? activeGroup.groupName : 'Over All' }]);
    };
    let calculateRow = (obj) => {
        let amount = 0;

        for (let i = 0; i < selectedList.length; i++) {
            selectedList[i].amount = selectedList[i].qty * selectedList[i].perUnitValue;
            amount += selectedList[i].amount
        }
        model.amount = amount;
        model.totalAmount = amount - (model.discount || 0);
        // model.remainingAmount = model.totalAmount - model.advanceAmount;
        model.remainingAmount = model.totalAmount - (model.advanceAmount || 0);
        setSelectedList([...selectedList]);
    };
    let delRow = (i) => {
        selectedList.splice(i, 1);
        setSelectedList([...selectedList]);
        let amount = 0;
        selectedList.forEach((x) => (amount += x.amount));
        model.amount = amount;
        model.totalAmount = amount - (model.discount || 0);
        setSelectedList([...selectedList]);
    };
    let addOther = () => {
        let arr = [];
        if (!otherModel.name) {
            arr.push("Required : Description in Other");
        }
        if (!otherModel.qty) {
            arr.push("Required : Quantity in Other");
        }
        if (!otherModel.perUnitValue) {
            arr.push("Required : Per Unit Value in Other");
        }

        if (arr.length > 0) {
            setShowMessage(true);
            setMessage(arr);
        } else {
            let activeGroup = groupNameList && groupNameList.length > 0 ? groupNameList.find(x => x.isActive) : null
            selectedList.push({ ...otherModel, groupName: activeGroup ? activeGroup.groupName : 'Over All' });
            setSelectedList([...selectedList]);
            calculateRow();
            setOpenOtherModal(false);
            setOtherModel({})
        }
    };
    const navigate = useNavigate()
    const saveEstimate = () => {
        setSaveLoader(true)
        model.detailsArray = [...selectedList]
        Post('estimate', model).then((res) => {
            setSaveLoader(false)
            if (res.status) {
                navigate('/estimate')
                setShowMessage(true)
                setMessage("Estimate Save Successfully")
            } else {
                setShowMessage(true)
                setMessage(res.errors)
            }
        }).catch(err => {
            setSaveLoader(false)
            console.log()
            setShowMessage(true)
            setMessage(err.message)
        })
    }

    let getEstimateById = () => {
        Get('estimate', params.id).then(res => {
            setModel({ ...res.data })
            setSelectedList([...res.data?.detailsArray])
            // calculateRow()
        }).catch(err => {
            setMessage(err.message)
            setShowMessage(true)
        })
    }
    useEffect(() => {
        if (params.id) {
            getEstimateById()
        }
    }, [])
    return <>
        <BAShowError open={showMessage} close={(e) => setShowMessage(e)} message={message} />
        <BAModal
            modalTitle="Add Other Item"
            innerContent={
                <Box>
                    <Grid container>
                        <Grid md={3} sm={12} item>
                            <Box className="p-2">
                                <BAInput
                                    value={otherModel.name}
                                    onChange={(e) =>
                                        setOtherModel({ ...otherModel, name: e.target.value })
                                    }
                                    required={true}
                                    label="Description"
                                />
                            </Box>
                        </Grid>
                        <Grid md={3} sm={12} item>
                            <Box className="p-2">
                                <BAInput
                                    value={otherModel.unit}
                                    onChange={(e) =>
                                        setOtherModel({ ...otherModel, unit: e.target.value })
                                    }
                                    label="Unit"
                                />
                            </Box>
                        </Grid>
                        <Grid md={3} sm={12} item>
                            <Box required={true} className="p-2">
                                <BAInput
                                    type="number"
                                    value={otherModel.qty}
                                    onChange={(e) => {
                                        otherModel.amount =
                                            e.target.value * otherModel.perUnitValue;
                                        setOtherModel({ ...otherModel, qty: e.target.value });
                                    }}
                                    label="Quantity"
                                />
                            </Box>
                        </Grid>
                        <Grid md={3} sm={12} item>
                            <Box className="p-2">
                                <BAInput
                                    type="number"
                                    value={otherModel.perUnitValue}
                                    onChange={(e) => {
                                        otherModel.amount = e.target.value * otherModel.qty;
                                        setOtherModel({
                                            ...otherModel,
                                            perUnitValue: e.target.value,
                                        });
                                    }}
                                    required={true}
                                    label="Per Unit Value"
                                />
                            </Box>
                        </Grid>
                        <Grid md={3} sm={12} item>
                            <Box className="p-2">
                                <BAInput
                                    value={otherModel.amount}
                                    onChange={(e) =>
                                        setOtherModel({ ...otherModel, amount: e.target.value })
                                    }
                                    disabled={true}
                                    label="Amount"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            }
            modalFooter={
                <Box className="text-end">
                    <BAButton onClick={addOther} label="Add" />
                </Box>
            }
            open={openOtherModal}
            close={(e) => {
                setOtherModel({});
                setOpenOtherModal(e);
            }}
        />
        <Box>
            <BAScreenHeader title='Estimate' buttonsList={[
                {
                    displayField: <BAButton loading={saveLoader} onClick={saveEstimate} label='Save' />
                }
            ]} />
            <Paper className="p-3">
                <Grid container>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput required={true} value={model.customerName} onChange={(e) => fillModel('customerName', e.target.value)} label='Customer Name' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.companyName} onChange={(e) => fillModel('companyName', e.target.value)} label='Company Name' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput required={true} value={model.contactNo} onChange={(e) => fillModel('contactNo', e.target.value)} label='Contact No' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput value={model.email} onChange={(e) => fillModel('email', e.target.value)} label='Email' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BADatepicker value={model.dateOfEstimation} onChange={(e) => fillModel('dateOfEstimation', e.target.value)} label='Estimation Date' />
                        </Box>
                    </Grid>
                    <Grid item md={4}>
                        <Box className="p-2">
                            <BAInput type='number' value={model.estimatedDays} onChange={(e) => fillModel('estimatedDays', e.target.value)} label='Estimation Days' />
                        </Box>
                    </Grid>
                    <Grid item md={12}>
                        <Box className="p-2">
                            <BATextarea value={model.address} onChange={(e) => fillModel('address', e.target.value)} label='Address' />
                        </Box>
                    </Grid>
                    <Grid item md={12}>
                        <Box className="p-2">
                            <BATextarea value={model.description} onChange={(e) => fillModel('description', e.target.value)} label='Description' />
                        </Box>
                    </Grid>


                    <Grid md={12} sm={12} item>
                        <Box className="bg-light rounded shadow p-1 border">
                            <Grid container>
                                <Grid item md={3}>
                                    <Box
                                        className="p-2 d-flex align-items-center border rounded"
                                    >
                                        <BAInput value={groupName} onChange={(e) => setGroupName(e.target.value)} label='Group Name' />
                                        <BAIconbutton onClick={addGroupName} icon={<CheckIcon />} />
                                    </Box>
                                </Grid>
                                <Grid item md={9}>
                                    {groupNameList && groupNameList.length > 0 && <Box className="p-3">
                                        <Stack direction="row" spacing={1}>
                                            {groupNameList.map((x, i) => <Chip label={x.groupName} color={x.isActive ? "primary" : "default"} onClick={() => activeGroupName(i)} />)}
                                        </Stack>
                                    </Box>}
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid md={12} sm={12} item>
                        <Grid container>
                            <Grid md={3} sm={3} item>
                                <Box className="p-3">
                                    <Box className="p-1">
                                        <BAInput value={filterVal} onChange={(e) => {
                                            setFilterVal(e.target.value)
                                            filterCat(e.target.value)
                                        }} label='Search' />
                                    </Box>
                                    {filterDetailList.length > 0 ? filterDetailList.map((x, i) => (
                                        <Box
                                            key={i}
                                            onClick={() => addInRecept(x)}
                                            className="border mb-2 p-2 particular rounded"
                                        >
                                            <Typography variant="h6">{x.name}</Typography>
                                        </Box>
                                    )) : detailsList.map((x, i) => (
                                        <Box
                                            key={i}
                                            onClick={() => addInRecept(x)}
                                            className="border mb-2 p-2 particular rounded"
                                        >
                                            <Typography variant="h6">{x.name}</Typography>
                                        </Box>
                                    ))}
                                    <Box
                                        onClick={() => setOpenOtherModal(true)}
                                        className="border mb-2 p-2 particular rounded"
                                    >
                                        <Typography variant="h6">Other</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid md={9} sm={9} item>
                                <Box className="p-3">
                                    <Box>
                                        <BAGrid isGrouping={true} groupName='groupName'
                                            gridCols={[
                                                {
                                                    label: "Delete",
                                                    key: "delete",
                                                    className: "btnCell",
                                                    displayField: (e, i) => (
                                                        <BAIconbutton
                                                            color="error"
                                                            onClick={() => delRow(i)}
                                                            icon={<DeleteIcon />}
                                                        />
                                                    ),
                                                },
                                                {
                                                    label: "Particular",
                                                    key: "name",
                                                },
                                                {
                                                    label: "Quantity",
                                                    key: "qty",
                                                    displayField: (obj, i) => (
                                                        <BAInput
                                                            type="number"
                                                            label={selectedList[i].unit}
                                                            value={selectedList[i].qty}
                                                            onChange={(e) => {
                                                                selectedList[i].qty = +e.target.value;
                                                                calculateRow(selectedList[i]);
                                                            }}
                                                        />
                                                    ),
                                                },
                                                {
                                                    label: "Per Unit Amount",
                                                    key: "perUnit",
                                                    displayField: (obj, i) => (
                                                        <BAInput
                                                            type="number"
                                                            label={`per ${obj.unit}`}
                                                            value={selectedList[i].perUnitValue}
                                                            onChange={(e) => {
                                                                selectedList[i].perUnitValue =
                                                                    +e.target.value;
                                                                calculateRow(selectedList[i]);
                                                            }}
                                                        />
                                                    ),
                                                },
                                                {
                                                    label: "Amount",
                                                    key: "amount",
                                                    displayField: (obj, i) => (
                                                        <BAInput
                                                            label="Amount"
                                                            disabled={true}
                                                            value={selectedList[i].amount}
                                                            onChange={(e) =>
                                                                (selectedList[i].amount = +e.target.value)
                                                            }
                                                        />
                                                    ),
                                                },
                                            ]}
                                            datasource={selectedList}
                                        />
                                    </Box>
                                </Box>
                                <Box className="w-50 ms-auto">
                                    <table className="table table-bordered">
                                        <tr>
                                            <th>Amount</th>
                                            <td>
                                                <input
                                                    className="w-100 text-center fs-5 border-0"
                                                    placeholder="0"
                                                    disabled
                                                    value={model.amount ? Number(model.amount).toFixed(2) : 0}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Installation Charges</th>
                                            <td>
                                                <input
                                                    className="w-100 bg-light text-center fs-5 border-0"
                                                    placeholder="0"
                                                    value={model.installationCharges}
                                                    onChange={(e) => {
                                                        model.totalAmount = +model.amount + +e.target.value;

                                                        setModel({ ...model, installationCharges: e.target.value });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Total</th>
                                            <td>
                                                <input
                                                    className="w-100 text-center fs-5 border-0"
                                                    placeholder="0"
                                                    disabled
                                                    value={model.totalAmount ? Number(model.totalAmount).toFixed(2) : 0}
                                                />
                                            </td>
                                        </tr>


                                    </table>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    </>
}